export default __webpack_public_path__ + "static/media/arena_7.29a19b9e.jpeg";